module.exports = __webpack_public_path__ + "img/hcml_gallery0.ac939b63.jpg";